module.exports = __webpack_public_path__ + "static/media/9import-21.5726859c.xlsx";